import { render, staticRenderFns } from "./FormationDda.vue?vue&type=template&id=66ee8b4d&"
import script from "./FormationDda.vue?vue&type=script&lang=js&"
export * from "./FormationDda.vue?vue&type=script&lang=js&"
import style0 from "./FormationDda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports